<div class="animated fadeIn">
    <p>admin-dashboard works!</p>
</div>